export type ExpenseStatus = 'paid' | 'unpaid' | 'no_payment_required' | 'pay_today' | 'marked_for_deletion';
export type TransactionType = 'expense' | 'income';

export interface Expense {
  id: string;
  date: string;
  currency: string;
  name: string;
  amount: number;
  amountByn: number | null;
  exchangeRate: number | null;
  exchangeRateDate: string | null;
  originalText: string;
  userId: string;
  type: TransactionType;
  paymentDate: string | null;
  status: ExpenseStatus;
  isConfirmed: boolean;
  costCategory: string | null;
  contractor: string | null;
  comment: string | null;
  createdAt: string;
}

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface UpdateExpenseData {
  date?: string;
  currency?: string;
  name?: string;
  amount?: number;
  paymentDate?: string | null;
  status?: ExpenseStatus;
  costCategory?: string | null;
  contractor?: string | null;
  comment?: string | null;
  type?: TransactionType;
}

export const EXPENSE_STATUS_LABELS: Record<ExpenseStatus, string> = {
  paid: 'Оплачен',
  unpaid: 'Не оплачен',
  no_payment_required: 'Не требует оплаты',
  pay_today: 'Оплатить сегодня',
  marked_for_deletion: 'Помечен на удаление',
};

export const INCOME_CATEGORIES = ['Выручка опт', 'Выручка розница'];

export const filterCategoriesByType = (categories: string[], type?: TransactionType): string[] => {
  if (type === 'income') return categories.filter((c) => INCOME_CATEGORIES.includes(c));
  if (type === 'expense') return categories.filter((c) => !INCOME_CATEGORIES.includes(c));
  return categories;
};

export const EXPENSE_STATUS_COLORS: Record<ExpenseStatus, string> = {
  paid: 'bg-green-100 text-green-800',
  unpaid: 'bg-red-100 text-red-800',
  no_payment_required: 'bg-gray-100 text-gray-800',
  pay_today: 'bg-yellow-100 text-yellow-800',
  marked_for_deletion: 'bg-purple-100 text-purple-800',
};
